var React = require('react');

function Resource (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.2 0H4.8C2.148 0 0 2.12562 0 4.75V14.25C0 16.8744 2.148 19 4.8 19H19.2C21.852 19 24 16.8744 24 14.25V4.75C24 2.12562 21.852 0 19.2 0ZM16.968 11.6019C16.68 11.8394 16.284 11.9344 15.912 11.8394L2.58 8.60938C2.94 7.7425 3.792 7.125 4.8 7.125H19.2C20.004 7.125 20.712 7.52875 21.156 8.1225L16.968 11.6019ZM4.8 2.375H19.2C20.52 2.375 21.6 3.44375 21.6 4.75V5.40313C20.892 4.99938 20.076 4.75 19.2 4.75H4.8C3.924 4.75 3.108 4.99938 2.4 5.40313V4.75C2.4 3.44375 3.48 2.375 4.8 2.375Z","fill":"currentColor"}));
}

Resource.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none"};

module.exports = Resource;

Resource.default = Resource;
